module.exports = __webpack_public_path__ + "static/media/grownUpBackground2.f100ef0e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/resource/ui/grownUpBackground2.jpg
// module id = 388
// module chunks = 0